const ERROR_PREFIX = '0x08c379a0'
const PANIC_ERROR_PREFIX = '0x4e487b71'

// Signature of TransactionDeadlinePassed
const EXPIRED_PREFIX = '0x5bf6f916'

export { ERROR_PREFIX, PANIC_ERROR_PREFIX, EXPIRED_PREFIX }
